import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { MobileNavLink } from '../MobileNavMenuData';

const websiteManageHome = '/wedding/manage/website/manage';

const designs = {
  title: 'Explore Designs',
  path: '/wedding/manage/website/designs',
};
const addEvent = {
  title: 'Add an Event',
  path: websiteManageHome,
};
const collectRsvps = {
  title: 'Collect RSVPs',
  path: websiteManageHome,
};

const activeLinks = [
  { title: 'Your Website', path: websiteManageHome },
  { title: 'Edit Website', path: websiteManageHome },
];

const aboutLinks = [
  { title: 'About Websites', path: '/wedding-planning/website' },
  {
    title: 'Website FAQs',
    path: '/faq/category/115000342412-wedding-website',
  },
];

export default function getMobileWebsiteMenuData(userContext: UserContext): MobileNavLink[][] {
  const hasWebsite = Boolean(userContext.wedding_account?.website_onboarding_completed);
  const activeWebsiteLinks = [activeLinks, [designs], aboutLinks];
  const inactiveWebsiteLinks = [[designs, addEvent, collectRsvps], aboutLinks];
  return hasWebsite ? activeWebsiteLinks : inactiveWebsiteLinks;
}
